import styled from '@emotion/styled';
import ReactSelect from 'react-select';

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    color: white;
    font-size: 14px;
    margin-right: 5px;
  }
`;

export const Select = styled(ReactSelect)``;

Select.defaultProps = {
  styles: {
    container: (styles) => ({
      ...styles,
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: '#172b4d',
      margin: '0 0 5px',
      boxShadow:
        '0px 1px 15px 0px hsl(0deg 0% 0% / 55%), 0 0 0 hsl(0deg 0% 0%)',
    }),
    control: (styles) => ({
      ...styles,
      backgroundColor: 'transparent',
      flexWrap: 'nowrap',
      border: 0,
      height: 80,
      padding: '20px 10px',
    }),
    input: (styles) => ({
      ...styles,
      color: 'white',
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'white',
    }),
    option: (styles, props) => {
      let backgroundColor = 'transparent';
      if (props.isSelected) {
        backgroundColor = '#364663';
      }
      return {
        ...styles,
        backgroundColor,
        color: 'white',
        cursor: 'pointer',
        padding: '15px 10px',
        borderBottom: '1px solid #364663',
      };
    },
  },
};
